import { takeLatest, put, call } from 'redux-saga/effects';

import { findControlePragaDoenca } from '../service';

import {
  FIND_CONTROLE_PRAGA_DOENCA,
  FIND_CONTROLE_PRAGA_DOENCA_PENDING,
  FIND_CONTROLE_PRAGA_DOENCA_SUCCESS,
  FIND_CONTROLE_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

function* sagaFindControlePragaDoenca(action) {
  yield put({ type: FIND_CONTROLE_PRAGA_DOENCA_PENDING })

  try {
    const registro = yield call(findControlePragaDoenca, action.id)

    // Mapeamento de strings do backend para números do frontend
    const statusStringToNumber = {
      'DETECTADO': 0,
      'PLANEJADO': 1,
      'EM_TRATAMENTO': 2,
      'TRATADO': 3,
      'CANCELADO': 4,
    };

    // Converte o status de string para número
    let statusNumerico = registro.status;
    if (typeof registro.status === 'string') {
      statusNumerico = statusStringToNumber[registro.status] ?? 0;
    }

    // Transforma os dados da API para o formato esperado pelo formulário
    const registroTransformado = {
      ...registro,
      // Mapeia 'responsavel' da API para 'funcionario' no frontend
      funcionario: registro.responsavel || null,
      // Extrai o tipo da praga/doença para o campo tipo
      tipo: registro.pragaDoenca?.tipo || null,
      // Converte o status de string para número
      status: statusNumerico ?? 0,
    }

    yield put({ type: FIND_CONTROLE_PRAGA_DOENCA_SUCCESS, registro: registroTransformado })

  } catch (error) {

    yield put({ type: FIND_CONTROLE_PRAGA_DOENCA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindControlePragaDoenca() {
  yield takeLatest(FIND_CONTROLE_PRAGA_DOENCA, sagaFindControlePragaDoenca)
}
